@if(cancelPaymentTemplate){
<div [innerHTML]="compiledTemplate | safeHtml" (click)="onActionClick($event)"></div>
}
